<template>
    <div class="main">
        <div class="save">
            <!--
            <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            -->
        </div>
        <div class="clear"></div>
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="版本名称" prop="versionName">
                    <el-input v-model="form.versionName"></el-input>
                </el-form-item>
                  <el-form-item label="版本编号" prop="versionCode">
                    <el-input type="number" v-model="form.versionCode"></el-input>
                </el-form-item>
              <el-form-item label="上传APK" prop="apkUrl">
                <sy-doc-upload v-model="form.apkUrl"  width="width:600px;"></sy-doc-upload>
              </el-form-item>
              <el-form-item label="下载二维码" prop="Pic">
                <sy-pic-upload v-model="form.Pic"  width="width:600px;"></sy-pic-upload>
              </el-form-item>
               <el-form-item label="小程序二维码" prop="wxPic">
                <sy-pic-upload v-model="form.wxPic"  width="width:600px;"></sy-pic-upload>
              </el-form-item>
            </el-form>

            <div class="save">
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
    </div>
</template>


<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data() {
            return {
                form: {versionName:"1.0",companyName:"",apkUrl:"",Pic:"",wxPic:"",versionCode:0},
                rules: {
                 
                },
                loading:false
            }
        },
        methods: {
            save:function () {
                if(this.form.apkUrl=="" ||typeof(this.form.apkUrl) == "undefined"){
                    alert("请先上传文件!");
                    return;
                }
                let url = "server/system/upgrade.ashx?cmd=Save"
                util.saveForm(url,this.$refs.form,this.form,this.loadFn("loading"),result=> {
                    util.msgSuc("保存成功")
                })
            }
        },
        created() {
            let _that = this
            let url = "server/system/upgrade.ashx?cmd=GetOne"
            util.get(url,this.form,this.progressFn,result=> {
                if(result.data[0].versionName) {
                    _that.form.versionName = result.data[0].versionName
                    _that.form.versionCode = result.data[0].versionCode
                    _that.form.apkUrl = result.data[0].downloadUrl
                    _that.form.Pic = result.data[0].downloadPic
                    _that.form.wxPic = result.data[0].wxPic
                }
            })
        }
    }
</script>

<style scoped="">
    .main{
        margin: 10px 30px;
        width: 80%;
    }
   .save{
       float: right;margin:0 20px 10px 0
   }

    .clear{
        clear: both;
    }
</style>





// WEBPACK FOOTER //
// src/pages/system/Upgrade.vue